import React, { Component } from 'react';
import '../../scss/CandidateDetail.scss';
import _ from 'lodash';

export default class CandidateDetail extends Component {
  render() {
    let { candidate, issue } = this.props;
    let fullName = `${candidate.firstName} ${candidate.lastName}`;
    let candidateImage = {
      backgroundImage: `url(assets/images/candidates/${_.kebabCase(fullName)}.png)`
    };
    return (
      <div className="CandidateDetail">
        <div style={candidateImage} className="CandidateDetail__image" />
        <h3 className="CandidateDetail__name">{fullName}</h3>
        {candidate.incumbent === 'y' && <div className="CandidateDetail__incumbent">Incumbent</div>}
        
        <p className="CandidateDetail__position">
          {candidate[issue]}
        </p>
        
        {candidate.website ?
          <a href={candidate.website} className="CandidateDetail__website" target="_blank">Candidate&apos;s Website</a>
        :
          <span className="CandidateDetail__note">No Candidate Website Found</span>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/CandidateDetail.js